// This file is auto-generated. Do not edit manually.
// Run `yarn tokens:build` to regenerate.

import { TypographyOptions } from '@mui/material/styles/createTypography';

export const typographyTheme: TypographyOptions = {
  A1: {
    fontFamily: 'var(--tokens-by-app-typography-a-1-font-family)',
    fontWeight: 'var(--tokens-by-app-typography-a-1-font-weight)',
    fontSize: 'var(--tokens-by-app-typography-a-1-font-size)',
    lineHeight: 'var(--tokens-by-app-typography-a-1-line-height)',
    letterSpacing: 'var(--tokens-by-app-typography-a-1-letter-spacing)',
  },
  A2: {
    fontFamily: 'var(--tokens-by-app-typography-a-2-font-family)',
    fontWeight: 'var(--tokens-by-app-typography-a-2-font-weight)',
    fontSize: 'var(--tokens-by-app-typography-a-2-font-size)',
    lineHeight: 'var(--tokens-by-app-typography-a-2-line-height)',
    letterSpacing: 'var(--tokens-by-app-typography-a-2-letter-spacing)',
  },
  A3: {
    fontFamily: 'var(--tokens-by-app-typography-a-3-font-family)',
    fontWeight: 'var(--tokens-by-app-typography-a-3-font-weight)',
    fontSize: 'var(--tokens-by-app-typography-a-3-font-size)',
    lineHeight: 'var(--tokens-by-app-typography-a-3-line-height)',
    letterSpacing: 'var(--tokens-by-app-typography-a-3-letter-spacing)',
  },
  C12: {
    fontFamily: 'var(--tokens-by-app-typography-c-12-font-family)',
    fontWeight: 'var(--tokens-by-app-typography-c-12-font-weight)',
    fontSize: 'var(--tokens-by-app-typography-c-12-font-size)',
    lineHeight: 'var(--tokens-by-app-typography-c-12-line-height)',
    letterSpacing: 'var(--tokens-by-app-typography-c-12-letter-spacing)',
  },
  C14: {
    fontFamily: 'var(--tokens-by-app-typography-c-14-font-family)',
    fontWeight: 'var(--tokens-by-app-typography-c-14-font-weight)',
    fontSize: 'var(--tokens-by-app-typography-c-14-font-size)',
    lineHeight: 'var(--tokens-by-app-typography-c-14-line-height)',
    letterSpacing: 'var(--tokens-by-app-typography-c-14-letter-spacing)',
  },
  C16: {
    fontFamily: 'var(--tokens-by-app-typography-c-16-font-family)',
    fontWeight: 'var(--tokens-by-app-typography-c-16-font-weight)',
    fontSize: 'var(--tokens-by-app-typography-c-16-font-size)',
    lineHeight: 'var(--tokens-by-app-typography-c-16-line-height)',
    letterSpacing: 'var(--tokens-by-app-typography-c-16-letter-spacing)',
  },
  h1: {
    fontFamily: 'var(--tokens-by-app-typography-h-1-font-family)',
    fontWeight: 'var(--tokens-by-app-typography-h-1-font-weight)',
    fontSize: 'var(--tokens-by-app-typography-h-1-font-size)',
    lineHeight: 'var(--tokens-by-app-typography-h-1-line-height)',
    letterSpacing: 'var(--tokens-by-app-typography-h-1-letter-spacing)',
  },
  h2: {
    fontFamily: 'var(--tokens-by-app-typography-h-2-font-family)',
    fontWeight: 'var(--tokens-by-app-typography-h-2-font-weight)',
    fontSize: 'var(--tokens-by-app-typography-h-2-font-size)',
    lineHeight: 'var(--tokens-by-app-typography-h-2-line-height)',
    letterSpacing: 'var(--tokens-by-app-typography-h-2-letter-spacing)',
  },
  h3: {
    fontFamily: 'var(--tokens-by-app-typography-h-3-font-family)',
    fontWeight: 'var(--tokens-by-app-typography-h-3-font-weight)',
    fontSize: 'var(--tokens-by-app-typography-h-3-font-size)',
    lineHeight: 'var(--tokens-by-app-typography-h-3-line-height)',
    letterSpacing: 'var(--tokens-by-app-typography-h-3-letter-spacing)',
  },
  h4: {
    fontFamily: 'var(--tokens-by-app-typography-h-4-font-family)',
    fontWeight: 'var(--tokens-by-app-typography-h-4-font-weight)',
    fontSize: 'var(--tokens-by-app-typography-h-4-font-size)',
    lineHeight: 'var(--tokens-by-app-typography-h-4-line-height)',
    letterSpacing: 'var(--tokens-by-app-typography-h-4-letter-spacing)',
  },
  h5: {
    fontFamily: 'var(--tokens-by-app-typography-h-5-font-family)',
    fontWeight: 'var(--tokens-by-app-typography-h-5-font-weight)',
    fontSize: 'var(--tokens-by-app-typography-h-5-font-size)',
    lineHeight: 'var(--tokens-by-app-typography-h-5-line-height)',
    letterSpacing: 'var(--tokens-by-app-typography-h-5-letter-spacing)',
  },
  h6: {
    fontFamily: 'var(--tokens-by-app-typography-h-6-font-family)',
    fontWeight: 'var(--tokens-by-app-typography-h-6-font-weight)',
    fontSize: 'var(--tokens-by-app-typography-h-6-font-size)',
    lineHeight: 'var(--tokens-by-app-typography-h-6-line-height)',
    letterSpacing: 'var(--tokens-by-app-typography-h-6-letter-spacing)',
  },
  L10B: {
    fontFamily: 'var(--tokens-by-app-typography-l-10-b-font-family)',
    fontWeight: 'var(--tokens-by-app-typography-l-10-b-font-weight)',
    fontSize: 'var(--tokens-by-app-typography-l-10-b-font-size)',
    lineHeight: 'var(--tokens-by-app-typography-l-10-b-line-height)',
    letterSpacing: 'var(--tokens-by-app-typography-l-10-b-letter-spacing)',
    textTransform: 'uppercase',
  },
  L10M: {
    fontFamily: 'var(--tokens-by-app-typography-l-10-m-font-family)',
    fontWeight: 'var(--tokens-by-app-typography-l-10-m-font-weight)',
    fontSize: 'var(--tokens-by-app-typography-l-10-m-font-size)',
    lineHeight: 'var(--tokens-by-app-typography-l-10-m-line-height)',
    letterSpacing: 'var(--tokens-by-app-typography-l-10-m-letter-spacing)',
    textTransform: 'uppercase',
  },
  L10R: {
    fontFamily: 'var(--tokens-by-app-typography-l-10-r-font-family)',
    fontWeight: 'var(--tokens-by-app-typography-l-10-r-font-weight)',
    fontSize: 'var(--tokens-by-app-typography-l-10-r-font-size)',
    lineHeight: 'var(--tokens-by-app-typography-l-10-r-line-height)',
    letterSpacing: 'var(--tokens-by-app-typography-l-10-r-letter-spacing)',
    textTransform: 'uppercase',
  },
  L12B: {
    fontFamily: 'var(--tokens-by-app-typography-l-12-b-font-family)',
    fontWeight: 'var(--tokens-by-app-typography-l-12-b-font-weight)',
    fontSize: 'var(--tokens-by-app-typography-l-12-b-font-size)',
    lineHeight: 'var(--tokens-by-app-typography-l-12-b-line-height)',
    letterSpacing: 'var(--tokens-by-app-typography-l-12-b-letter-spacing)',
    textTransform: 'uppercase',
  },
  L12M: {
    fontFamily: 'var(--tokens-by-app-typography-l-12-m-font-family)',
    fontWeight: 'var(--tokens-by-app-typography-l-12-m-font-weight)',
    fontSize: 'var(--tokens-by-app-typography-l-12-m-font-size)',
    lineHeight: 'var(--tokens-by-app-typography-l-12-m-line-height)',
    letterSpacing: 'var(--tokens-by-app-typography-l-12-m-letter-spacing)',
    textTransform: 'uppercase',
  },
  L12R: {
    fontFamily: 'var(--tokens-by-app-typography-l-12-r-font-family)',
    fontWeight: 'var(--tokens-by-app-typography-l-12-r-font-weight)',
    fontSize: 'var(--tokens-by-app-typography-l-12-r-font-size)',
    lineHeight: 'var(--tokens-by-app-typography-l-12-r-line-height)',
    letterSpacing: 'var(--tokens-by-app-typography-l-12-r-letter-spacing)',
    textTransform: 'uppercase',
  },
  L14B: {
    fontFamily: 'var(--tokens-by-app-typography-l-14-b-font-family)',
    fontWeight: 'var(--tokens-by-app-typography-l-14-b-font-weight)',
    fontSize: 'var(--tokens-by-app-typography-l-14-b-font-size)',
    lineHeight: 'var(--tokens-by-app-typography-l-14-b-line-height)',
    letterSpacing: 'var(--tokens-by-app-typography-l-14-b-letter-spacing)',
    textTransform: 'uppercase',
  },
  L14M: {
    fontFamily: 'var(--tokens-by-app-typography-l-14-m-font-family)',
    fontWeight: 'var(--tokens-by-app-typography-l-14-m-font-weight)',
    fontSize: 'var(--tokens-by-app-typography-l-14-m-font-size)',
    lineHeight: 'var(--tokens-by-app-typography-l-14-m-line-height)',
    letterSpacing: 'var(--tokens-by-app-typography-l-14-m-letter-spacing)',
    textTransform: 'uppercase',
  },
  L14R: {
    fontFamily: 'var(--tokens-by-app-typography-l-14-r-font-family)',
    fontWeight: 'var(--tokens-by-app-typography-l-14-r-font-weight)',
    fontSize: 'var(--tokens-by-app-typography-l-14-r-font-size)',
    lineHeight: 'var(--tokens-by-app-typography-l-14-r-line-height)',
    letterSpacing: 'var(--tokens-by-app-typography-l-14-r-letter-spacing)',
    textTransform: 'uppercase',
  },
  L8M: {
    fontFamily: 'var(--tokens-by-app-typography-l-8-m-font-family)',
    fontWeight: 'var(--tokens-by-app-typography-l-8-m-font-weight)',
    fontSize: 'var(--tokens-by-app-typography-l-8-m-font-size)',
    lineHeight: 'var(--tokens-by-app-typography-l-8-m-line-height)',
    letterSpacing: 'var(--tokens-by-app-typography-l-8-m-letter-spacing)',
    textTransform: 'uppercase',
  },
  metriclg: {
    fontFamily: 'var(--tokens-by-app-typography-metric-lg-font-family)',
    fontWeight: 'var(--tokens-by-app-typography-metric-lg-font-weight)',
    fontSize: 'var(--tokens-by-app-typography-metric-lg-font-size)',
    lineHeight: 'var(--tokens-by-app-typography-metric-lg-line-height)',
    letterSpacing: 'var(--tokens-by-app-typography-metric-lg-letter-spacing)',
  },
  metricmd: {
    fontFamily: 'var(--tokens-by-app-typography-metric-md-font-family)',
    fontWeight: 'var(--tokens-by-app-typography-metric-md-font-weight)',
    fontSize: 'var(--tokens-by-app-typography-metric-md-font-size)',
    lineHeight: 'var(--tokens-by-app-typography-metric-md-line-height)',
    letterSpacing: 'var(--tokens-by-app-typography-metric-md-letter-spacing)',
  },
  metricsm: {
    fontFamily: 'var(--tokens-by-app-typography-metric-sm-font-family)',
    fontWeight: 'var(--tokens-by-app-typography-metric-sm-font-weight)',
    fontSize: 'var(--tokens-by-app-typography-metric-sm-font-size)',
    lineHeight: 'var(--tokens-by-app-typography-metric-sm-line-height)',
    letterSpacing: 'var(--tokens-by-app-typography-metric-sm-letter-spacing)',
  },
  metricxs: {
    fontFamily: 'var(--tokens-by-app-typography-metric-xs-font-family)',
    fontWeight: 'var(--tokens-by-app-typography-metric-xs-font-weight)',
    fontSize: 'var(--tokens-by-app-typography-metric-xs-font-size)',
    lineHeight: 'var(--tokens-by-app-typography-metric-xs-line-height)',
    letterSpacing: 'var(--tokens-by-app-typography-metric-xs-letter-spacing)',
  },
  P10B: {
    fontFamily: 'var(--tokens-by-app-typography-p-10-b-font-family)',
    fontWeight: 'var(--tokens-by-app-typography-p-10-b-font-weight)',
    fontSize: 'var(--tokens-by-app-typography-p-10-b-font-size)',
    lineHeight: 'var(--tokens-by-app-typography-p-10-b-line-height)',
    letterSpacing: 'var(--tokens-by-app-typography-p-10-b-letter-spacing)',
  },
  P10M: {
    fontFamily: 'var(--tokens-by-app-typography-p-10-m-font-family)',
    fontWeight: 'var(--tokens-by-app-typography-p-10-m-font-weight)',
    fontSize: 'var(--tokens-by-app-typography-p-10-m-font-size)',
    lineHeight: 'var(--tokens-by-app-typography-p-10-m-line-height)',
    letterSpacing: 'var(--tokens-by-app-typography-p-10-m-letter-spacing)',
  },
  P10R: {
    fontFamily: 'var(--tokens-by-app-typography-p-10-r-font-family)',
    fontWeight: 'var(--tokens-by-app-typography-p-10-r-font-weight)',
    fontSize: 'var(--tokens-by-app-typography-p-10-r-font-size)',
    lineHeight: 'var(--tokens-by-app-typography-p-10-r-line-height)',
    letterSpacing: 'var(--tokens-by-app-typography-p-10-r-letter-spacing)',
  },
  P12B: {
    fontFamily: 'var(--tokens-by-app-typography-p-12-b-font-family)',
    fontWeight: 'var(--tokens-by-app-typography-p-12-b-font-weight)',
    fontSize: 'var(--tokens-by-app-typography-p-12-b-font-size)',
    lineHeight: 'var(--tokens-by-app-typography-p-12-b-line-height)',
    letterSpacing: 'var(--tokens-by-app-typography-p-12-b-letter-spacing)',
  },
  P12M: {
    fontFamily: 'var(--tokens-by-app-typography-p-12-m-font-family)',
    fontWeight: 'var(--tokens-by-app-typography-p-12-m-font-weight)',
    fontSize: 'var(--tokens-by-app-typography-p-12-m-font-size)',
    lineHeight: 'var(--tokens-by-app-typography-p-12-m-line-height)',
    letterSpacing: 'var(--tokens-by-app-typography-p-12-m-letter-spacing)',
  },
  P12R: {
    fontFamily: 'var(--tokens-by-app-typography-p-12-r-font-family)',
    fontWeight: 'var(--tokens-by-app-typography-p-12-r-font-weight)',
    fontSize: 'var(--tokens-by-app-typography-p-12-r-font-size)',
    lineHeight: 'var(--tokens-by-app-typography-p-12-r-line-height)',
    letterSpacing: 'var(--tokens-by-app-typography-p-12-r-letter-spacing)',
  },
  P14B: {
    fontFamily: 'var(--tokens-by-app-typography-p-14-b-font-family)',
    fontWeight: 'var(--tokens-by-app-typography-p-14-b-font-weight)',
    fontSize: 'var(--tokens-by-app-typography-p-14-b-font-size)',
    lineHeight: 'var(--tokens-by-app-typography-p-14-b-line-height)',
    letterSpacing: 'var(--tokens-by-app-typography-p-14-b-letter-spacing)',
  },
  P14M: {
    fontFamily: 'var(--tokens-by-app-typography-p-14-m-font-family)',
    fontWeight: 'var(--tokens-by-app-typography-p-14-m-font-weight)',
    fontSize: 'var(--tokens-by-app-typography-p-14-m-font-size)',
    lineHeight: 'var(--tokens-by-app-typography-p-14-m-line-height)',
    letterSpacing: 'var(--tokens-by-app-typography-p-14-m-letter-spacing)',
  },
  P14R: {
    fontFamily: 'var(--tokens-by-app-typography-p-14-r-font-family)',
    fontWeight: 'var(--tokens-by-app-typography-p-14-r-font-weight)',
    fontSize: 'var(--tokens-by-app-typography-p-14-r-font-size)',
    lineHeight: 'var(--tokens-by-app-typography-p-14-r-line-height)',
    letterSpacing: 'var(--tokens-by-app-typography-p-14-r-letter-spacing)',
  },
  P16B: {
    fontFamily: 'var(--tokens-by-app-typography-p-16-b-font-family)',
    fontWeight: 'var(--tokens-by-app-typography-p-16-b-font-weight)',
    fontSize: 'var(--tokens-by-app-typography-p-16-b-font-size)',
    lineHeight: 'var(--tokens-by-app-typography-p-16-b-line-height)',
    letterSpacing: 'var(--tokens-by-app-typography-p-16-b-letter-spacing)',
  },
  P16M: {
    fontFamily: 'var(--tokens-by-app-typography-p-16-m-font-family)',
    fontWeight: 'var(--tokens-by-app-typography-p-16-m-font-weight)',
    fontSize: 'var(--tokens-by-app-typography-p-16-m-font-size)',
    lineHeight: 'var(--tokens-by-app-typography-p-16-m-line-height)',
    letterSpacing: 'var(--tokens-by-app-typography-p-16-m-letter-spacing)',
  },
  P16R: {
    fontFamily: 'var(--tokens-by-app-typography-p-16-r-font-family)',
    fontWeight: 'var(--tokens-by-app-typography-p-16-r-font-weight)',
    fontSize: 'var(--tokens-by-app-typography-p-16-r-font-size)',
    lineHeight: 'var(--tokens-by-app-typography-p-16-r-line-height)',
    letterSpacing: 'var(--tokens-by-app-typography-p-16-r-letter-spacing)',
  },
  P18B: {
    fontFamily: 'var(--tokens-by-app-typography-p-18-b-font-family)',
    fontWeight: 'var(--tokens-by-app-typography-p-18-b-font-weight)',
    fontSize: 'var(--tokens-by-app-typography-p-18-b-font-size)',
    lineHeight: 'var(--tokens-by-app-typography-p-18-b-line-height)',
    letterSpacing: 'var(--tokens-by-app-typography-p-18-b-letter-spacing)',
  },
  P18M: {
    fontFamily: 'var(--tokens-by-app-typography-p-18-m-font-family)',
    fontWeight: 'var(--tokens-by-app-typography-p-18-m-font-weight)',
    fontSize: 'var(--tokens-by-app-typography-p-18-m-font-size)',
    lineHeight: 'var(--tokens-by-app-typography-p-18-m-line-height)',
    letterSpacing: 'var(--tokens-by-app-typography-p-18-m-letter-spacing)',
  },
  P18R: {
    fontFamily: 'var(--tokens-by-app-typography-p-18-r-font-family)',
    fontWeight: 'var(--tokens-by-app-typography-p-18-r-font-weight)',
    fontSize: 'var(--tokens-by-app-typography-p-18-r-font-size)',
    lineHeight: 'var(--tokens-by-app-typography-p-18-r-line-height)',
    letterSpacing: 'var(--tokens-by-app-typography-p-18-r-letter-spacing)',
  },
  P20B: {
    fontFamily: 'var(--tokens-by-app-typography-p-20-b-font-family)',
    fontWeight: 'var(--tokens-by-app-typography-p-20-b-font-weight)',
    fontSize: 'var(--tokens-by-app-typography-p-20-b-font-size)',
    lineHeight: 'var(--tokens-by-app-typography-p-20-b-line-height)',
    letterSpacing: 'var(--tokens-by-app-typography-p-20-b-letter-spacing)',
  },
  P20M: {
    fontFamily: 'var(--tokens-by-app-typography-p-20-m-font-family)',
    fontWeight: 'var(--tokens-by-app-typography-p-20-m-font-weight)',
    fontSize: 'var(--tokens-by-app-typography-p-20-m-font-size)',
    lineHeight: 'var(--tokens-by-app-typography-p-20-m-line-height)',
    letterSpacing: 'var(--tokens-by-app-typography-p-20-m-letter-spacing)',
  },
  P20R: {
    fontFamily: 'var(--tokens-by-app-typography-p-20-r-font-family)',
    fontWeight: 'var(--tokens-by-app-typography-p-20-r-font-weight)',
    fontSize: 'var(--tokens-by-app-typography-p-20-r-font-size)',
    lineHeight: 'var(--tokens-by-app-typography-p-20-r-line-height)',
    letterSpacing: 'var(--tokens-by-app-typography-p-20-r-letter-spacing)',
  },
  P40B: {
    fontFamily: 'var(--tokens-by-app-typography-p-40-b-font-family)',
    fontWeight: 'var(--tokens-by-app-typography-p-40-b-font-weight)',
    fontSize: 'var(--tokens-by-app-typography-p-40-b-font-size)',
    lineHeight: 'var(--tokens-by-app-typography-p-40-b-line-height)',
    letterSpacing: 'var(--tokens-by-app-typography-p-40-b-letter-spacing)',
  },
  P8B: {
    fontFamily: 'var(--tokens-by-app-typography-p-8-b-font-family)',
    fontWeight: 'var(--tokens-by-app-typography-p-8-b-font-weight)',
    fontSize: 'var(--tokens-by-app-typography-p-8-b-font-size)',
    lineHeight: 'var(--tokens-by-app-typography-p-8-b-line-height)',
    letterSpacing: 'var(--tokens-by-app-typography-p-8-b-letter-spacing)',
  },
  P8M: {
    fontFamily: 'var(--tokens-by-app-typography-p-8-m-font-family)',
    fontWeight: 'var(--tokens-by-app-typography-p-8-m-font-weight)',
    fontSize: 'var(--tokens-by-app-typography-p-8-m-font-size)',
    lineHeight: 'var(--tokens-by-app-typography-p-8-m-line-height)',
    letterSpacing: 'var(--tokens-by-app-typography-p-8-m-letter-spacing)',
  },
};
